import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Button } from "app/components/button";
import { ConditionalButton } from "app/components/buttons";
import { CardBody } from "app/components/card-body";
import { CardFooter } from "app/components/card-footer";
import { CardHeader } from "app/components/card-header";
import { Checkbox } from "app/components/checkbox";
import { Column } from "app/components/column";
import { Container } from "app/components/container";
import { DFlexResponsive } from "app/components/d-flex-responsive";
import { Input } from "app/components/input";
import { RouteError } from "app/components/route-error";
import { Row } from "app/components/row";
import { useEmpresa } from "app/contexts";
import toast from "react-hot-toast";
import { correoRegex } from "app/utils";

const initialState = {
  correo: {
    correo_electronico_direccion: "",
    correo_electronico_principal: false,
  },
  error: null,
};

export function CorreoElectronicoForm() {
  const params = useParams();
  const navigate = useNavigate();

  const [state, setState] = useState(initialState);

  const {
    addCorreoElectronico,
    getCorreoElectronico,
    updateCorreoElectronico,
  } = useEmpresa();

  useEffect(() => {
    try {
      if (!!params.index) {
        const correo = getCorreoElectronico(parseInt(params.index));

        setState((state) => ({
          ...state,
          correo,
        }));
      }
    } catch (error) {
      setState((state) => ({ ...state, error }));
    }
  }, [params.index, getCorreoElectronico]);

  function handleSubmit(e) {
    e.preventDefault();

    try {
      if (!!params.index) {
        const updated = updateCorreoElectronico(
          parseInt(params.index),
          state.correo
        );

        if (!!updated) {
          toast.success("¡Dirección de correo electrónico actualizada!");

          return navigate("../../");
        }
      } else {
        const added = addCorreoElectronico(state.correo);

        if (!!added) {
          toast.success("¡Dirección de correo electrónico agregada!");

          return navigate("../../");
        }
      }
    } catch (error) {
      return toast.error(error.message);
    }
  }

  if (!!state.error) {
    return <RouteError message={state.error.message} navigateTo="../../" />;
  }

  return (
    <div className="col-sm-12 col-xl-6 offset-xl-3">
      <form className="card" onSubmit={handleSubmit}>
        <CardHeader
          header={`${
            !!params.index ? "Editar" : "Agregar"
          } dirección de correo electrónico`}
        />

        <CardBody>
          <Container>
            <Row>
              <Column>
                <Input
                  type="email"
                  placeholder="Dirección de correo electrónico"
                  value={state.correo.correo_electronico_direccion}
                  onChange={(e) =>
                    setState((state) => ({
                      ...state,
                      correo: {
                        ...state.correo,
                        correo_electronico_direccion: e.target.value,
                      },
                    }))
                  }
                  title="p. ej. usuario@email.com"
                  pattern={correoRegex.source}
                  autoFocus
                />
              </Column>

              <Column>
                <Checkbox
                  label="¿Es una dirección de correo principal?"
                  checked={state.correo.correo_electronico_principal}
                  onChange={(e) =>
                    setState((state) => ({
                      ...state,
                      correo: {
                        ...state.correo,
                        correo_electronico_principal: e.target.checked,
                      },
                    }))
                  }
                />
              </Column>
            </Row>
          </Container>
        </CardBody>

        <CardFooter>
          <DFlexResponsive justifyContent="end">
            <ConditionalButton
              type="submit"
              condition={!params.index}
              titleWhenTrue="Agregar"
              titleWhenFalse="Actualizar"
            />

            <Button
              color="secondary"
              title="Cancelar"
              outline
              onClick={() => navigate("../../")}
            />
          </DFlexResponsive>
        </CardFooter>
      </form>
    </div>
  );
}
